module.exports = __webpack_public_path__ + "1793882494189/fonts/line-awesome.4d42f5f.ttf";